
import utils from '@/components/tools/utils'
import auction from '@/components/tools/auction'

export default {
  components: {
    // VueSlider
  },
  props: {
    targetPrice: {
      type: Number,
      default: undefined
    },
    currentPrice: {
      type: Number,
      default: undefined
    },
    sliderData: {
      type: Array,
      default: undefined
    },
    marks: {
      type: Object,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: true
    },
    renegotiationThreshold: {
      type: Number,
      default: 0.9
    }
  },

  computed: {
    value: {
      get () {
        return this.$store.state.product.biddingAdviserValue
      },
      set (value) {
        this.$store.commit('product/setBiddingAdviserValue', value)
      }
    },
    chance () {
      return auction.biddingAdviserChance(this.value, this.targetPrice)
    },
    highChance () {
      return this.targetPrice * this.renegotiationThreshold
    }

  },

  created () {
    this.$nextTick(() => {
      if (this.$refs.slider) {
        this.$refs.slider.setIndex(28)
      }
    })
  },

  methods: {
    formatCurrency (value) {
      return utils.formatCurrency(value)
    }
  }

}
